import { useEffect, useState } from "react";

// Components
import FooterSocialItem from "components/atoms/FooterSocialItem";

// Constants
import { FOOTER_FACEBOOK, FOOTER_SOCIAL } from "constants/navigation";
import { STORAGE_LANGUAGE_NAME } from "constants/variables";

// Hooks
import useTranslate from "hooks/useTranslate";

import "./styles.sass";

const FooterSocialList = () => {
  const [disableMenuState, setDisableMenuState] = useState(false);
  const [showFacebookIcon, setShowFacebookIcon] = useState(false);
  const t = useTranslate();
  const currentLanguage = localStorage.getItem(STORAGE_LANGUAGE_NAME);

  const { VITE_APP_PROJECT_NAME } = import.meta.env;

  useEffect(() => {
    if (currentLanguage === "RU") {
      setDisableMenuState(true);
    } else if (currentLanguage === "BN" || currentLanguage === "EN") {
      setShowFacebookIcon(true);
    } else {
      setShowFacebookIcon(false);
      setDisableMenuState(false);
    }
  }, [currentLanguage]);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {!disableMenuState && (
        <div className="Footer__social">
          <div className="Footer__social_menu_title">
            {t("footer.socialnetwork")}
          </div>
          <div className="Footer__social_wrapper">
            {FOOTER_SOCIAL(VITE_APP_PROJECT_NAME).map((social) => (
              <FooterSocialItem item={social} key={social.id} />
            ))}
            {showFacebookIcon &&
              FOOTER_FACEBOOK(VITE_APP_PROJECT_NAME).map((social) => (
                <FooterSocialItem item={social} key={social.id} />
              ))}
          </div>
        </div>
      )}
    </>
  );
};

export default FooterSocialList;
